var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessProfileManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,10 H40 V38 H8 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,16 H34 V20 H14 Z M14,24 H29 V28 H14 Z M14,32 H24 V35 H14 Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36,28 A7,7 0,1 0,36,42 A7,7 0,1 0,36,28",
    fill: "#00D4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36,31 A4,4 0,1 0,36,39 A4,4 0,1 0,36,31",
    fill: "#0D0D12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34,26 H38 V31 H34 Z M34,39 H38 V44 H34 Z M27,33 H32 V37 H27 Z M40,33 H45 V37 H40 Z",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessProfileManage);
export default __webpack_public_path__ + "static/media/p4r_business_profile_manage.fdd817bf31a04367119e5408b7215898.svg";
export { ForwardRef as ReactComponent };